/* eslint-disable */
import { useState } from 'react';
import { authAPI } from '../services/api';

const inputStyle = { padding:'12px 14px', border:'1.5px solid #ddd', borderRadius:'8px', fontSize:'14px', background:'#fafafa', outline:'none' };

function Login({ onLoginBerhasil }) {
  const [mode, setMode] = useState('login'); // 'login' | 'register'

  const [form, setForm]       = useState({ username:'', password:'', divisi:'' });
  const [pesan, setPesan]     = useState({ teks:'', tipe:'' });
  const [loading, setLoading] = useState(false);

  const [formReg, setFormReg]   = useState({ nama:'', username:'', no_hp:'', password:'', konfirmasi:'', divisi:'' });
  const [pesanReg, setPesanReg] = useState({ teks:'', tipe:'' });
  const [loadingReg, setLoadingReg] = useState(false);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }
  function handleChangeReg(e) {
    setFormReg({ ...formReg, [e.target.name]: e.target.value });
  }

  function gantiMode(m) {
    setMode(m);
    setPesan({ teks:'', tipe:'' });
    setPesanReg({ teks:'', tipe:'' });
  }

  async function prosesLogin() {
    if (!form.username) { setPesan({ teks:'⚠️ Username tidak boleh kosong', tipe:'error' }); return; }
    if (!form.password) { setPesan({ teks:'⚠️ Password tidak boleh kosong', tipe:'error' }); return; }
    if (!form.divisi)   { setPesan({ teks:'⚠️ Pilih divisi terlebih dahulu', tipe:'error' }); return; }

    setLoading(true);
    setPesan({ teks:'', tipe:'' });

    try {
      const result = await authAPI.login(form.username, form.password, form.divisi);

      if (result.ok && result.data.success) {
        localStorage.setItem('erp_token', result.data.token);
        localStorage.setItem('erp_user',  JSON.stringify(result.data.user));
        setPesan({ teks:'✅ Login berhasil! Mengalihkan...', tipe:'sukses' });
        setTimeout(() => onLoginBerhasil(result.data.user), 800);
      } else {
        setLoading(false);
        setPesan({ teks: `❌ ${result.data.message || 'Login gagal'}`, tipe:'error' });
        setForm({ ...form, password:'' });
      }
    } catch (err) {
      setLoading(false);
      setPesan({ teks:'❌ Tidak dapat terhubung ke server. Pastikan backend berjalan.', tipe:'error' });
    }
  }

  async function prosesRegister() {
    if (!formReg.nama)     { setPesanReg({ teks:'⚠️ Nama tidak boleh kosong', tipe:'error' }); return; }
    if (!formReg.username) { setPesanReg({ teks:'⚠️ Username tidak boleh kosong', tipe:'error' }); return; }
    if (!formReg.no_hp)    { setPesanReg({ teks:'⚠️ No. HP tidak boleh kosong', tipe:'error' }); return; }
    if (!formReg.password) { setPesanReg({ teks:'⚠️ Password tidak boleh kosong', tipe:'error' }); return; }
    if (formReg.password.length < 6) { setPesanReg({ teks:'⚠️ Password minimal 6 karakter', tipe:'error' }); return; }
    if (formReg.password !== formReg.konfirmasi) { setPesanReg({ teks:'⚠️ Konfirmasi password tidak cocok', tipe:'error' }); return; }
    if (!formReg.divisi)   { setPesanReg({ teks:'⚠️ Pilih divisi terlebih dahulu', tipe:'error' }); return; }

    setLoadingReg(true);
    setPesanReg({ teks:'', tipe:'' });

    try {
      const result = await authAPI.register(formReg.nama, formReg.username, formReg.no_hp, formReg.password, formReg.divisi);

      if (result.ok && result.data.success) {
        setPesanReg({ teks:`✅ ${result.data.message}`, tipe:'sukses' });
        setFormReg({ nama:'', username:'', no_hp:'', password:'', konfirmasi:'', divisi:'' });
      } else {
        setPesanReg({ teks: `❌ ${result.data.message || 'Pendaftaran gagal'}`, tipe:'error' });
      }
    } catch (err) {
      setPesanReg({ teks:'❌ Tidak dapat terhubung ke server. Pastikan backend berjalan.', tipe:'error' });
    } finally {
      setLoadingReg(false);
    }
  }

  function handleKeyDown(e) { if (e.key === 'Enter') prosesLogin(); }
  function handleKeyDownReg(e) { if (e.key === 'Enter') prosesRegister(); }

  return (
    <div style={{
      minHeight:'100vh',
      background:'linear-gradient(135deg, #1a3a5c 0%, #2d6a9f 100%)',
      display:'flex', alignItems:'center', justifyContent:'center',
      fontFamily:"'Segoe UI', sans-serif"
    }}>
      <div style={{ width:'100%', maxWidth:'420px', padding:'20px' }}>

        {/* HEADER */}
        <div style={{ textAlign:'center', marginBottom:'24px', color:'white' }}>
          <div style={{ fontSize:'56px', marginBottom:'2px' }}> <img src="/kop mkmj.jpg" alt="Kop MKMJ" style={{ maxWidth:'100%', height:'auto' }} /> </div>
          <h1 style={{ fontSize:'36px', fontWeight:'700', margin:'0', fontFamily:'cambria' }}>MKMJ</h1>
          <p style={{ fontSize:'14px', opacity:'0.8', marginTop:'4px' }}>PT Mitra Karya Mandiri Jaya</p>
        </div>

        {/* CARD */}
        <div style={{
          background:'white', borderRadius:'16px', padding:'36px 32px',
          boxShadow:'0 20px 60px rgba(0,0,0,0.3)',
          display:'flex', flexDirection:'column', gap:'16px'
        }}>

          {/* TOGGLE LOGIN / DAFTAR */}
          <div style={{ display:'flex', background:'#f0f4f8', borderRadius:'10px', padding:'4px' }}>
            <button onClick={()=>gantiMode('login')} style={{
              flex:1, padding:'9px', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'700', cursor:'pointer',
              background: mode==='login' ? 'white' : 'transparent',
              color: mode==='login' ? '#1a3a5c' : '#888',
              boxShadow: mode==='login' ? '0 2px 6px rgba(0,0,0,0.08)' : 'none',
            }}>Masuk</button>
            <button onClick={()=>gantiMode('register')} style={{
              flex:1, padding:'9px', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'700', cursor:'pointer',
              background: mode==='register' ? 'white' : 'transparent',
              color: mode==='register' ? '#1a3a5c' : '#888',
              boxShadow: mode==='register' ? '0 2px 6px rgba(0,0,0,0.08)' : 'none',
            }}>Daftar</button>
          </div>

          {mode==='login' ? (
            <>
              <h2 style={{ fontSize:'18px', color:'#1a3a5c', textAlign:'center', margin:'0' }}>Masuk ke Sistem</h2>

              {pesan.teks && (
                <div style={{
                  padding:'10px 14px', borderRadius:'8px', fontSize:'13px', fontWeight:'500', textAlign:'center',
                  background: pesan.tipe==='error' ? '#fdedec' : '#eafaf1',
                  color:      pesan.tipe==='error' ? '#c0392b' : '#1e8449',
                  border:     pesan.tipe==='error' ? '1px solid #f5b7b1' : '1px solid #a9dfbf',
                }}>{pesan.teks}</div>
              )}

              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'13px', fontWeight:'600', color:'#444' }}>Username</label>
                <input type="text" name="username" value={form.username} onChange={handleChange} onKeyDown={handleKeyDown}
                  placeholder="Masukkan username" style={inputStyle} />
              </div>

              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'13px', fontWeight:'600', color:'#444' }}>Password</label>
                <input type="password" name="password" value={form.password} onChange={handleChange} onKeyDown={handleKeyDown}
                  placeholder="Masukkan password" style={inputStyle} />
              </div>

              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'13px', fontWeight:'600', color:'#444' }}>Divisi</label>
                <select name="divisi" value={form.divisi} onChange={handleChange} style={inputStyle}>
                  <option value="">-- Pilih Divisi --</option>
                  <option value="direktur">Direktur</option>
                  <option value="proyek">Manajer Proyek</option>
                  <option value="logistik">Logistik & Pengadaan</option>
                  <option value="hse">HSE / K3</option>
                  <option value="keuangan">Keuangan</option>
                </select>
              </div>

              <div style={{ display:'flex', alignItems:'center', gap:'6px', fontSize:'11px', color:'#aaa' }}>
                <div style={{ width:'8px', height:'8px', borderRadius:'50%', background:'#27ae60' }}></div>
                Terhubung ke server mkmj.cloud
              </div>

              <button onClick={prosesLogin} disabled={loading} style={{
                width:'100%', padding:'13px',
                background: loading ? '#aaa' : 'linear-gradient(135deg, #1a3a5c, #2d6a9f)',
                color:'white', border:'none', borderRadius:'8px', fontSize:'15px', fontWeight:'600',
                cursor: loading ? 'not-allowed' : 'pointer',
              }}>
                {loading ? '⏳ Memproses...' : 'Masuk'}
              </button>

              <p style={{ textAlign:'center', fontSize:'12px', color:'#888', margin:'0' }}>
                Lupa password? Hubungi Administrator
              </p>
            </>
          ) : (
            <>
              <h2 style={{ fontSize:'18px', color:'#1a3a5c', textAlign:'center', margin:'0' }}>Daftar Akun Baru</h2>
              <p style={{ fontSize:'12px', color:'#888', textAlign:'center', margin:'-8px 0 0' }}>
                Akun akan aktif setelah disetujui Administrator
              </p>

              {pesanReg.teks && (
                <div style={{
                  padding:'10px 14px', borderRadius:'8px', fontSize:'13px', fontWeight:'500', textAlign:'center',
                  background: pesanReg.tipe==='error' ? '#fdedec' : '#eafaf1',
                  color:      pesanReg.tipe==='error' ? '#c0392b' : '#1e8449',
                  border:     pesanReg.tipe==='error' ? '1px solid #f5b7b1' : '1px solid #a9dfbf',
                }}>{pesanReg.teks}</div>
              )}

              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'13px', fontWeight:'600', color:'#444' }}>Nama Lengkap</label>
                <input type="text" name="nama" value={formReg.nama} onChange={handleChangeReg} onKeyDown={handleKeyDownReg}
                  placeholder="Masukkan nama lengkap" style={inputStyle} />
              </div>

              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'13px', fontWeight:'600', color:'#444' }}>Username</label>
                <input type="text" name="username" value={formReg.username} onChange={handleChangeReg} onKeyDown={handleKeyDownReg}
                  placeholder="Untuk login nanti" style={inputStyle} />
              </div>

              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'13px', fontWeight:'600', color:'#444' }}>No. HP</label>
                <input type="text" name="no_hp" value={formReg.no_hp} onChange={handleChangeReg} onKeyDown={handleKeyDownReg}
                  placeholder="08xxxxxxxxxx" style={inputStyle} />
              </div>

              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'13px', fontWeight:'600', color:'#444' }}>Password</label>
                <input type="password" name="password" value={formReg.password} onChange={handleChangeReg} onKeyDown={handleKeyDownReg}
                  placeholder="Minimal 6 karakter" style={inputStyle} />
              </div>

              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'13px', fontWeight:'600', color:'#444' }}>Konfirmasi Password</label>
                <input type="password" name="konfirmasi" value={formReg.konfirmasi} onChange={handleChangeReg} onKeyDown={handleKeyDownReg}
                  placeholder="Ulangi password" style={inputStyle} />
              </div>

              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'13px', fontWeight:'600', color:'#444' }}>Divisi</label>
                <select name="divisi" value={formReg.divisi} onChange={handleChangeReg} style={inputStyle}>
                  <option value="">-- Pilih Divisi --</option>
                  <option value="direktur">Direktur</option>
                  <option value="proyek">Manajer Proyek</option>
                  <option value="logistik">Logistik & Pengadaan</option>
                  <option value="hse">HSE / K3</option>
                  <option value="keuangan">Keuangan</option>
                </select>
              </div>

              <button onClick={prosesRegister} disabled={loadingReg} style={{
                width:'100%', padding:'13px',
                background: loadingReg ? '#aaa' : 'linear-gradient(135deg, #1e8449, #27ae60)',
                color:'white', border:'none', borderRadius:'8px', fontSize:'15px', fontWeight:'600',
                cursor: loadingReg ? 'not-allowed' : 'pointer',
              }}>
                {loadingReg ? '⏳ Memproses...' : 'Daftar'}
              </button>
            </>
          )}
        </div>

        {/* FOOTER */}
        <div style={{ textAlign:'center', marginTop:'20px', color:'rgba(255,255,255,0.6)', fontSize:'12px' }}>
          © 2026 PT Mitra Karya Mandiri Jaya · ERP v1.0
        </div>

      </div>
    </div>
  );
}

export default Login;